import { institutionService } from "@/api/institutionService";
import { usePaginatedResource } from "@/hooks/usePaginatedResource";

const defaultFilters = { search: '' };
export const useInstitutions = () => usePaginatedResource(institutionService, defaultFilters);
